//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BiUserAccessService from '@/apps/data-platform/services/visualization/bi_user_access_service';
import UserAccessLogDetail from '@/modules/tasks/tableau/components/user-access/UserAccessLogDetail';
export default {
  name: 'UserAccessLogs',
  components: {
    UserAccessLogDetail: UserAccessLogDetail
  },
  props: {
    record: {
      type: Object,
      require: true,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      items: [],
      dateFrom: '',
      dateTo: new Date().toISOString().slice(0, 10),
      currentViewPage: 1
    };
  },
  computed: {
    fields: function fields() {
      return [{
        value: 'created_date',
        text: this.traductor('tablas.creation_time'),
        sortable: true
      }, {
        value: 'created_by',
        text: this.traductor('tablas.created_by'),
        sortable: true
      }, {
        value: 'user_bi',
        text: this.traductor('tablas.values'),
        sortable: true
      }, {
        value: 'type_id',
        text: this.traductor('tablas.type'),
        sortable: true
      }];
    },
    texts: function texts() {
      return {
        user: this.traductor('tablas.user'),
        name: this.traductor('tablas.name'),
        from: this.traductor('form_audiencia.desde'),
        to: this.traductor('form_audiencia.hasta')
      };
    }
  },
  created: function created() {
    this.getItems();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getItems: function getItems() {
      var _this = this;
      var params = {
        record: {
          document_id: this.record.user_id,
          date_from: this.dateFrom,
          date_to: this.dateTo
        }
      };
      BiUserAccessService.getLogsUserDP(params).then(function (response) {
        _this.items = response.data.result;
      });
    }
  }
};